<header class="relative pr-4 text-left">
  <h3 class="!m-0 !font-base !font-bold !text-base !leading-[20px]">
    {{ "RECOMMEND_WORK" | translate }}
  </h3>
  @if (items.length > 1) {
  <p class="mt-0.5 text-sm">
    {{ "WORK_SELECTION_SELECTED_COUNT" | translate: {count: items.length} }}
  </p>
  } @else {
  <p
    class="mt-[2px] text-sm !leading-[16px] text-grey dark:text-borders-dark truncate"
    [title]="worksService.getItemTitle(item)"
  >
    {{ worksService.getItemTitle(item) }} &middot;
    {{ workTypeLabels[item.type] | translate }} @if (item.releaseDate) {
    &middot; {{ releaseYear }} } @if (item.genres?.length) { &middot; }@for
    (genre of item.genres?.slice(0, 3); track genre; let last = $last) {
    {{ (getGenreTranslationKey(genre) | translate) + (last ? "" : ", ") }} }
  </p>
  } @if (isMobile) {
  <button
    type="button"
    class="absolute -right-0.5 -top-0.5 flex h-[32px] w-[32px] items-center justify-center rounded-full hover:bg-black/5 dark:hover:bg-white/5"
    [attr.aria-label]="'CLOSE_MODAL' | translate"
    (click)="closeModal(modalId ?? 'send_work_' + item._id)"
  >
    <span
      class="block h-[16px] w-[16px] bg-current mask-[url(/assets/images/icons/close.svg)] mask-center mask-no-repeat mask-size-[16px_16px]"
      aria-hidden="true"
    ></span>
  </button>
  }
</header>
<div
  class="form relative !mt-2"
  [ngClass]="isMobile ? '!mb-2' : '!mb-3'"
  [formGroup]="recommendationForm"
>
  <label for="recommendation-message" class="sr-only !m-0">{{
    (items.length > 1
      ? "RECOMMENDATION_OPTIONAL_COMMENT"
      : "WORK_SHARE.MESSAGE"
    ) | translate
  }}</label>
  <textarea
    id="recommendation-message"
    formControlName="comment"
    [attr.maxlength]="items.length > 1 ? null : 140"
    [rows]="items.length > 1 ? 2 : 1"
    [placeholder]="
      (items.length > 1
        ? 'RECOMMENDATION_OPTIONAL_COMMENT'
        : 'WORK_SHARE.MESSAGE'
      ) | translate
    "
    class="!mb-0 !py-[14px] !pr-[60px] !leading-[20px]"
    [readOnly]="isSending"
  ></textarea>
  @if (items.length < 2) {
  <span
    class="pointer-events-none absolute right-1.5 top-1/2 -translate-y-1/2 text-xs text-grey"
    >{{ recommendationForm.get("comment")?.value?.length ?? 0 }}/140</span
  >
  }
</div>
<div
  class="grid"
  [ngClass]="items.length < 2 && !isMobile ? 'grid-cols-2 gap-3' : 'gap-2'"
>
  <form
    [formGroup]="recommendationForm"
    (ngSubmit)="onSubmit()"
    class="relative !my-0 min-w-0"
  >
    <h4
      class="!mt-0 !mb-1.5 !font-base !text-xs !font-bold uppercase tracking-wide text-grey dark:text-borders-dark"
    >
      {{ "WORK_SHARE.INTERNAL" | translate }}
    </h4>
    <fieldset
      [disabled]="isSending"
      class="min-w-0"
      [attr.aria-label]="'WORK_SHARE.INTERNAL' | translate"
    >
      @if (friendsLoading) {
      <p class="py-1 text-sm" role="status">{{ "LOADING" | translate }}</p>
      } @else if (friendsError) {
      <p class="text-sm" role="alert">
        {{ "WORK_SHARE.FRIENDS_ERROR" | translate }}
      </p>
      <button type="button" class="text-sm underline" (click)="fetchFriends()">
        {{ "PUBLIC_WORK.RETRY" | translate }}
      </button>
      } @else if (friends.length) {
      <div class="relative">
        <input
          id="inviteUser"
          type="text"
          inputmode="search"
          class="search !h-[48px] !pl-[44px] !pr-[76px] !mb-0.5"
          formControlName="inviteUser"
          (input)="onUserSearch()"
          [placeholder]="'FIND_A_FRIEND' | translate"
          [attr.aria-label]="'FIND_A_FRIEND' | translate"
          #searchInput
          autocomplete="off"
        />
        <span
          aria-hidden="true"
          class="icon !h-[24px] !w-[24px] mask-[url(/assets/images/icons/search.svg)] mask-center mask-no-repeat mask-size-[24px_24px]"
        ></span>
        @if (isClearVisible) {
        <button
          type="button"
          class="absolute right-[2px] top-[2px] flex h-[44px] w-[72px] items-center justify-center text-sm text-grey dark:text-borders-dark hover:underline focus-visible:underline"
          (click)="clearSearch()"
          [attr.aria-label]="'CLEAR_SEARCH' | translate"
        >
          {{ "CLEAR" | translate }}
        </button>
        }
      </div>
      <div [ngClass]="friendsLayout">
        @for (friend of visibleFriends; track friend._id) {
        <button
          type="button"
          class="!m-0 flex items-center rounded-lg !bg-transparent !text-inherit hover:!bg-black/5 dark:hover:!bg-white/5"
          [ngClass]="
            isClearVisible
              ? 'w-full min-h-[40px] gap-1 !px-1 !py-0.5 text-left'
              : 'w-[64px] shrink-0 flex-col gap-[2px] !p-0.5'
          "
          [attr.aria-pressed]="isSelected(friend)"
          [attr.title]="friend.username"
          (click)="selectFriend(friend)"
        >
          <span
            class="relative block shrink-0 rounded-full"
            [ngClass]="{'ring-2 ring-primary': isSelected(friend)}"
          >
            <app-user-avatar
              class="block"
              [name]="friend.username"
              [picture]="friend.picture"
              [size]="isClearVisible ? 28 : 42"
            />
            @if (isSelected(friend)) {
            <span
              class="absolute -right-[3px] -bottom-[3px] flex h-[18px] w-[18px] items-center justify-center rounded-full border-2 border-white bg-primary dark:border-black-dark"
              aria-hidden="true"
              ><span
                class="block h-[10px] w-[10px] bg-black mask-[url(/assets/images/icons/check.svg)] mask-center mask-no-repeat mask-size-[10px_10px]"
              ></span
            ></span>
            }
          </span>
          <span
            class="min-w-0 truncate text-sm"
            [class.w-full]="!isClearVisible"
            >{{ friend.username }}</span
          >
        </button>
        }
      </div>
      @if (isClearVisible && filteredFriends.length > 4) {
      <p class="text-xs">{{ "WORK_SHARE.REFINE_SEARCH" | translate }}</p>
      } @if (isClearVisible && !filteredFriends.length) {
      <p class="py-1 text-sm">{{ "WORK_SHARE.NO_RESULT" | translate }}</p>
      } } @else {
      <p class="text-sm">{{ "WORK_SHARE.NO_FRIENDS" | translate }}</p>
      <button
        type="button"
        class="!m-0 !p-0 !bg-transparent !text-inherit text-sm underline whitespace-nowrap"
        (click)="openFriendSearch()"
      >
        {{ "FIND_FRIENDS" | translate }}
      </button>
      } @if (error?.error?.error) {
      <p class="text-form-error dark:text-form-errorLight text-sm" role="alert">
        {{ error?.error?.error! | translate }}
      </p>
      } @if (friends.length) {
      <button
        type="submit"
        class="btn btn-small full !mt-1.5 min-h-[44px] whitespace-nowrap disabled:!opacity-40 disabled:!cursor-not-allowed"
        [disabled]="isSending || selectedFriends.length === 0"
        [attr.aria-busy]="isSending"
        [attr.title]="sendLabel"
      >
        <span class="flex items-center justify-center gap-1"
          ><span
            class="block h-[16px] w-[16px] shrink-0 bg-current mask-[url(/assets/images/icons/send.svg)] mask-center mask-no-repeat mask-size-[16px_16px]"
            aria-hidden="true"
          ></span
          ><span class="min-w-0 truncate">{{ sendLabel }}</span></span
        >
      </button>
      }
    </fieldset>
  </form>
  @if (items.length < 2) {
  <app-external-work-share
    class="block min-w-0 border-borders-light dark:border-borders-darker"
    [ngClass]="isMobile ? 'border-t pt-2' : 'border-l pl-3'"
    [item]="item"
    [user]="user"
    [comment]="recommendationForm.get('comment')?.value ?? ''"
    [isMobile]="isMobile"
    (commentRestored)="
      recommendationForm.patchValue({comment: $event}, {emitEvent: false})
    "
  />
  }
</div>
<app-modal
  modalId="addFriendFromRecommendation"
  classes="!z-[110]"
  overlayClasses="!z-[105]"
  (modalClosed)="searchingFriends = false"
>
  @if (searchingFriends) { <app-add-friend [user]="user" /> }
</app-modal>
